var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBranchesLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 7.219C9 8.324 8.105 9.219 7 9.219C5.895 9.219 5 8.324 5 7.219C5 6.114 5.895 5.219 7 5.219C8.105 5.219 9 6.114 9 7.219ZM7 18C5.178 18 2 11.01 2 7C2 4.243 4.243 2 7 2C9.757 2 12 4.243 12 7C12 11.01 8.822 18 7 18ZM7 0C3.134 0 0 3.134 0 7C0 10.866 3.134 20 7 20C10.866 20 14 10.866 14 7C14 3.134 10.866 0 7 0Z",
    fill: "#878E99"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchesLocation);
export default __webpack_public_path__ + "static/media/branches-location.9910f7c2661bdc7d579ec499826cd256.svg";
export { ForwardRef as ReactComponent };